import { render, staticRenderFns } from "./SubscribeManager.vue?vue&type=template&id=fae2183a&"
import script from "./SubscribeManager.vue?vue&type=script&lang=js&"
export * from "./SubscribeManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports